<div class="switcher" [ngClass]="{'is-disabled': isDisabled}">
  <div class="switcher__handler" [ngClass]="'_' + activeIndex"></div>
  <button type="button" class="switcher__button" (click)="onSetActive(0)">
    <ng-content select="[leftTitle]"></ng-content>
  </button>
  <button type="button" class="switcher__button" (click)="onSetActive(1)">
    <ng-content select="[rightTitle]"></ng-content>
  </button>
</div>
